"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TimeOnly {
    static fromXmlTimeValue(xmlValue) {
        const i = xmlValue.indexOf(":");
        if (i !== -1) {
            const hour = parseInt(xmlValue.substring(0, i), 10);
            let i2 = xmlValue.indexOf(":", i + 1);
            if (i2 < 0) {
                i2 = undefined;
            }
            const minute = parseInt(xmlValue.substring(i + 1, i2), 10);
            if (isNaN(hour) || isNaN(minute)) {
                throw new Error("Cannot parse time value " + xmlValue);
            }
            else {
                return new TimeOnly(hour, minute);
            }
        }
    }
    static createFromDate(date) {
        if (date == null) {
            return null;
        }
        else {
            return new TimeOnly(date.getHours(), date.getMinutes());
        }
    }
    constructor(hour, minute) {
        this._hour = hour;
        this._minute = minute;
    }
    getHour() {
        return this._hour;
    }
    getMinute() {
        return this._minute;
    }
    getXMLTimeValue() {
        return this.getStringValue(true);
    }
    getStringValue(includeSeconds) {
        const h = `${this._hour}`;
        const m = `${this._minute}`;
        return (h.length === 1 ? "0" : "") + h + ":" + (m.length === 1 ? "0" : "") + m + (includeSeconds ? ":00" : "");
    }
}
exports.default = TimeOnly;
//# sourceMappingURL=TimeOnly.js.map